import useCar from "@/components/report/useCar";
import parking from "@/components/report/parking";
import stay from "@/components/report/stay";
import driving from "@/components/report/driving";
import nightDriving from "@/components/report/nightDriving";
import daily from "@/components/report/daily";
import refuel from "@/components/report/refuel";
import defuel from "@/components/report/defuel";
import reportAssess from "@/components/report/reportAssess";
import mi from "@/components/report/mi";
import offlineReport from "@/components/report/offlineReport";
var data = [
  {
    path: "/useCar",
    component: useCar,
    meta: {
      keepAlive: true
    }
  }, {
    path: "/stay",
    component: stay
  },
  {
    path: "/parking",
    component: parking
  },
  {
    path: "/reportAssess",
    component: reportAssess
  },
  
  {
    path: "/driving",
    component: driving,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/night",
    component: nightDriving
  },
  {
    path: "/daily",
    component: daily,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/refuel",
    component: refuel
  },
  {
    path: "/defuel",
    component: defuel
  },{
    path: "/offlineReport",
    component: offlineReport
  },{
    path: "/mi",
    component: mi
  },
  /*   {
    path: "/rule/gaofeng",
    component: () => import("@/components/rule/ruleGaofeng")
  } */
];
export default data;



// WEBPACK FOOTER //
// ./src/router/report.js